import React, { useEffect, useState } from 'react';
import { Loader2, AlertCircle } from 'lucide-react';
import MailHub from '../../../components/CRM/MailHub';
import AuthContext from '../../../components/Auth/AuthContext';
import { getMailToken } from './api';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Onglet Mail du panel /papaenmousse.
 * Récupère un jeton admin CRM court (laissez-passer) puis affiche l'outil
 * e-mail existant (MailHub) sur la boîte partagée. Aucune logique mail recodée.
 * Fournit un AuthContext minimal (user admin partagé) attendu par useMailHub,
 * sans déclencher le bootstrap complet d'AuthProvider (modales mot de passe/CGU).
 */
export default function MailPanelTab() {
  const [token, setToken] = useState(null);
  const [user, setUser] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const data = await getMailToken();
        if (!cancelled) { setToken(data.access_token); setUser(data.admin || null); }
      } catch (e) {
        if (!cancelled) setError(e.message || "Accès e-mail indisponible");
      }
    })();
    return () => { cancelled = true; };
  }, []);

  if (error) {
    return (
      <div className="bg-amber-50 border border-amber-200 rounded-xl p-6 flex items-start gap-3" data-testid="papa-mail-error">
        <AlertCircle className="text-amber-600 shrink-0 mt-0.5" size={22} />
        <div>
          <p className="font-semibold text-slate-900">Messagerie indisponible</p>
          <p className="text-slate-600 text-sm mt-1">{error}</p>
        </div>
      </div>
    );
  }

  if (!token) {
    return (
      <div className="flex items-center justify-center py-20 text-slate-500" data-testid="papa-mail-loading">
        <Loader2 className="animate-spin mr-2" size={20} /> Chargement de la messagerie…
      </div>
    );
  }

  return (
    <AuthContext.Provider value={{ user }}>
      <div className="h-[calc(100vh-200px)] min-h-[600px]" data-testid="papa-mail-panel">
        <MailHub backendUrl={BACKEND_URL} authToken={token} />
      </div>
    </AuthContext.Provider>
  );
}

